import { mapearEtapaPorStatus, obterStatusChave } from "./statusMapper.js";

/**
 * Recupera a etapa de rejeição gravada localmente quando uma empresa
 * é devolvida para ajustes. Isso permite que o stepper mostre em qual
 * etapa ela parou, mesmo após o backend "esquecer".
 *
 * Este módulo é uma adaptação do rejeicaoMapper do CadastroEmpresa,
 * calibrado para os status textuais da api-autorizacao-estagio-aprendiz.
 */

const CHAVES_DOCUMENTO = ["cnpj", "CNPJ", "cpf", "CPF", "documento"];

function lerRejeicaoHints() {
  if (typeof window === "undefined") return {};
  try {
    return JSON.parse(window.localStorage.getItem("empresa_rejeicao_hints") || "{}");
  } catch {
    return {};
  }
}

function extrairDocumento(...fontes) {
  for (const fonte of fontes) {
    if (!fonte || typeof fonte !== "object") continue;
    for (const chave of CHAVES_DOCUMENTO) {
      const valor = fonte[chave];
      if (String(valor || "").trim()) return valor;
    }
  }
  return "";
}

function extrairId(...fontes) {
  for (const fonte of fontes) {
    if (!fonte || typeof fonte !== "object") continue;
    const candidato = Number(
      fonte.id ?? fonte.ID ?? fonte.id_empresa ?? fonte.empresa_id,
    );
    if (Number.isInteger(candidato) && candidato > 0) return candidato;
  }
  return 0;
}

export function gravarHintRejeicao({ documento, id, statusAnterior, tipoPrograma } = {}) {
  if (typeof window === "undefined") return;
  try {
    const hints = JSON.parse(
      window.localStorage.getItem("empresa_rejeicao_hints") || "{}",
    );
    const docNorm = String(documento || "").replace(/\D/g, "");
    if (!docNorm && !Number.isInteger(id)) return;

    const tipoProgNorm = Number.isFinite(Number(tipoPrograma))
      ? Number(tipoPrograma)
      : undefined;

    const entrada = {
      statusAnterior: obterStatusChave(statusAnterior),
      atualizadoEm: Date.now(),
      tipoPrograma: tipoProgNorm,
    };

    if (docNorm) {
      hints[docNorm] = entrada;
    }
    if (Number.isInteger(id) && id > 0) {
      hints[`id:${id}`] = entrada;
    }

    window.localStorage.setItem(
      "empresa_rejeicao_hints",
      JSON.stringify(hints),
    );
  } catch {
    /* silencioso */
  }
}

export function obterEtapaRejeicaoPorHint(
  empresa,
  payload,
  empresaRef,
  requerSupex = false,
  tipoPrograma = 1,
) {
  const hints = lerRejeicaoHints();

  const documento = extrairDocumento(empresa, payload, empresaRef);
  const docNormalizado = String(documento || "").replace(/\D/g, "");

  let hint = null;
  if (docNormalizado && hints[docNormalizado]) hint = hints[docNormalizado];
  if (!hint) {
    const id = extrairId(empresa, empresaRef);
    if (id > 0 && hints[`id:${id}`]) hint = hints[`id:${id}`];
  }

  const statusAnterior = hint?.statusAnterior;
  if (!statusAnterior) return null;

  // Usa o tipoPrograma gravado no hint se existir (mais fiel ao momento da
  // rejeição); caso contrário, usa o tipoPrograma recebido por argumento.
  const tipoProgramaEfetivo =
    Number.isInteger(Number(hint?.tipoPrograma)) && hint.tipoPrograma
      ? Number(hint.tipoPrograma)
      : Number(tipoPrograma) || 1;

  return mapearEtapaPorStatus(statusAnterior, requerSupex, tipoProgramaEfetivo);
}
